import Event from 'entities/Event';

class Competition extends Event{
    getPermalink() {
        return super.getPermalink('skoly/souteze');
    }
}

export default Competition;